module.exports = __webpack_public_path__ + "media/images/common/headerimg-165114630cdb3ec115a7412cf4c3fa99.jpg";